import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { HubLoanerPhoneListItem, YardSpotConfigurationModel } from '../../../../administration/hub/models';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { ListServerPaginationStateModel } from '../../../../../../common/models';
import { AllocationViewActionIdentifierModel, UliDetailsModel } from '../../models';
import { Observable } from 'rxjs';
import { HubEndpoint } from '../../../../administration/hub/constants/hub-endpoint';

@Injectable({ providedIn: 'root' })
export class AllocationViewRegisterActionService {
  constructor(private http: WrapperHttpService) {}

  getPreparedUliDetails(identifier: AllocationViewActionIdentifierModel): Observable<UliDetailsModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Register}${AllocationViewEndpoint.Prepare}`;

    return this.http.withLoading().post(url, identifier);
  }

  getLoanerPhones(hubId: number, filter: string): Observable<ListServerPaginationStateModel<HubLoanerPhoneListItem>> {
    return this.http.withLoading().get(
      `${API_URL}${AllocationViewEndpoint.Hubs}/${hubId}${AllocationViewEndpoint.LoanerPhones}?` +
        getQueryStringFromObject({
          filter,
          available: true,
          loaned: false,
          limit: 10,
        }),
    );
  }

  getParkingSpots(hubId: number): Observable<YardSpotConfigurationModel[]> {
    return this.http
      .withLoading()
      .get(
        `${API_URL}${AllocationViewEndpoint.Hubs}/${hubId}${HubEndpoint.ParkingSpots}${AllocationViewEndpoint.Available}`,
      );
  }

  uliRegister(uli: UliDetailsModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Register}`;

    return this.http.withLoading().post<void>(url, uli);
  }
}
